import { render, staticRenderFns } from "./all_fly_data_item.vue?vue&type=template&id=672d2590&scoped=true&"
import script from "./all_fly_data_item.vue?vue&type=script&lang=js&"
export * from "./all_fly_data_item.vue?vue&type=script&lang=js&"
import style0 from "./all_fly_data_item.vue?vue&type=style&index=0&id=672d2590&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d2590",
  null
  
)

export default component.exports